import React from "react";

const ReadMoreCatherine = () => {
  return (
    <div>
      <div>
        <p  className="mb-2">
        She informed us that her approach employs a simplified in vitro model, omitting the reconstitution of food 
        chyme—a practice attempted by some studies over a decade ago. Consequently, direct extrapolation to the in vivo 
        scenario is not feasible, necessitating an in vivo model. Nevertheless, a distinct advantage lies in consistently 
        working with realistic exposure concentrations of cells, comparable to those found in food contamination. In summary, 
        her research findings indicate:
      </p>
      <p className="mb-2">
1. Cadmium (Cd), when administered at 'realistic' doses, is predominantly absorbed via the paracellular pathway. 
The oral bioavailability of Cd, being notably low (below 5%), can be attributed to its storage within enterocytes 
until their renewal.
</p>
<p className="mb-2">
2. Hence, the enterocyte emerges as the primary target cell for ingested Cd, offering avenues for an array of studies.
</p>
<p className="mb-2">
3. The absorption of Cd might extend beyond the free Cd2+ form. Certain organic complexes within contaminated foods could 
render Cd bioavailable, with the possibility that certain complexes are assimilated as they are, foregoing prior Cd release. 
The specific pathways for intestinal absorption depend on the chemical speciation of Cd and can exhibit variation.
</p>
<p className="mb-2">
4. Cd's disruption of signaling pathways that regulate the proliferation-differentiation cycle of enterocytes occurs at levels
 that do not compromise cell viability. Investigating the in vivo impact becomes a necessary next step.
</p>
<p className="mb-2">
5. The enterocyte's redox response to Cd might diverge based on its differentiation status.
</p>
<p className="mb-2">
6. Prolonged exposure to Cd within the intestinal lumen is likely to disturb intestinal health on a chronic basis.

When asked about our project, she expressed that it holds high relevance and originality, and she has confidence in its 
potential. She could not comment on the genetic engineering component, but regarding its practical application, she noted 
that conclusive insights would require in vivo studies, preferably using mice. She recommended this as a natural progression 
for our project. Additionally, she highlighted the importance of addressing the administration of modified bacteria. Ensuring 
their successful passage to the intestinal level, minimizing stomach-related loss, is a significant consideration and a 
potential question that might arise.
</p>
      <p className="mb-2">
Furthermore, she brought attention to the fact that previous research has indicated that Cadmium (Cd) can influence the gut's 
microbial flora, particularly relevant for individuals with Inflammatory Bowel Disease (IBD). In light of this, the selection
of commensal bacteria might warrant re-evaluation. Conversely, the proposed elimination method could potentially mitigate 
disturbances caused by luminal Cd on the gut's microbial balance. She emphasized that multiple key aspects deserve exploration 
from a comprehensive 'perspective' within our project.
        </p>

      </div>
    </div>
  );
};

export default ReadMoreCatherine;
